import React, { useEffect } from "react";
// import "./swadaaSecurity.css";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import { director_image, swadaa_security } from "../../assets";

import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./swadaaSecurity.css";
import SEO from "../../components/SEO/SEO";

const SwadaaSecurity = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  const navigate = useNavigate();
  return (
    <div>
      <SEO
        title="Security Services"
        description="Swadaa Security & Guards Limited provides professional manned guarding, surveillance, risk assessments, and emergency response services for businesses, events, and residences across Lagos and Nigeria."
        keywords="Swadaa Security, manned guarding, surveillance, security assessments, emergency response, event security, residential security, business protection"
      />
      <Navbar />
      <div className="homeAbout_sectionOneCont">
        <div className="homeAbout_sectionOne_gen">
          <div className="homeAbout_startedHeader">Swadaa </div>
          <div className="homeAbout_startedSub">Security & Guards</div>

          <div className="swaaddd_logo_security">
            <img src={swadaa_security} />
          </div>
          <div className="homeAbout_paraGen">
            <div>
              <div className="homeAbout_director_image">
                <div className="homeAbout_director_image____">
                  <img src={director_image} />
                </div>
              </div>
              <div className="homeAbout_director_name">
                Com. Chijioke Ugochukwu
              </div>
              <div className="homeAbout_director_title">Director General</div>
            </div>

            <div className="homeAbout_para">
              Our security services offer comprehensive solutions designed to
              meet the diverse needs of our clients. Utilizing state-of-the-art
              technology and a team of highly trained professionals, we provide
              reliable protection for various settings including businesses,
              events, and residential areas.{" "}
              <div style={{ marginTop: "20px" }}>
                Our services encompass security assessments, surveillance,
                manned guarding, and emergency response.{" "}
              </div>
              <div style={{ marginTop: "20px" }}>
                We prioritize the safety and peace of mind of our clients,
                ensuring they receive top-notch security tailored to their
                specific requirements.
              </div>
              <div style={{ marginTop: "20px" }}>
                Whether safeguarding events or securing residential properties,
                our expertise ensures optimal protection and peace of mind.
              </div>
            </div>
          </div>

          {/* <a
          href="https://api.whatsapp.com/send?phone=+2348033477608&text=I%20am%20reaching%20out%20to%20explore%20your%20business%20offering."
          target="_blank"
          className="getStarted_btn"
          style={{ textDecoration: "none" }}
        >
          Lets Get Started
        </a> */}

          <div
            // href="https://api.whatsapp.com/send?phone=+2348033477608&text=I%20am%20reaching%20out%20to%20explore%20your%20business%20offering."
            // target="_blank"
            className="getStarted_btn"
            style={{ textDecoration: "none" }}
            onClick={() => {
              navigate("/contact");
            }}
          >
            Lets Get Started
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SwadaaSecurity;
